export default __webpack_public_path__ + "static/media/32-lead.323ba96b.png";